import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { ShoppingCart, Bell, User, LogOut, ChevronDown, MapPin, RefreshCw } from 'lucide-react';
import { useApp } from '../context/AppContext';
import { ASSETS } from '../mock/data';

const DesktopHeader = ({ showLocation = true }) => {
  const nav = useNavigate();
  const { user, cart, address, logout, role } = useApp();
  const cartCount = cart.reduce((s, i) => s + i.qty, 0);

  const handleRefreshCatalog = () => {
    if (window.confirm('Reload the latest catalog?')) {
      localStorage.removeItem('c24_categories');
      localStorage.removeItem('c24_services');
      localStorage.removeItem('c24_offers');
      localStorage.removeItem('c24_data_version');
      window.location.reload();
    }
  };

  const linkClass = ({ isActive }) =>
    `text-sm font-semibold px-3 py-2 rounded-lg transition-colors ${isActive ? 'text-[#2E7D32] bg-[#E8F5E9]' : 'text-neutral-700 hover:bg-neutral-100'}`;

  const handleLogout = () => { logout(); nav('/'); };

  return (
    <header className="hidden md:block sticky top-0 z-40 bg-white border-b border-neutral-200 shadow-sm">
      <div className="max-w-[1280px] mx-auto px-6 py-2 flex items-center gap-8">
        <button onClick={() => nav(user ? (role === 'cleaner' ? '/cleaner/dashboard' : '/home') : '/')} className="flex items-center">
          <img src={ASSETS.logo} alt="Clean24" className="h-24 md:h-28 object-contain" />
        </button>

        {user && showLocation && (
          <button className="flex items-center gap-1.5 text-sm text-neutral-700 hover:text-[#2E7D32] transition-colors">
            <MapPin className="w-4 h-4 text-[#2E7D32]" />
            <span className="font-medium">{address}</span>
            <ChevronDown className="w-3.5 h-3.5" />
          </button>
        )}

        <nav className="ml-auto flex items-center gap-1">
          {user && role === 'customer' && (
            <>
              <NavLink to="/home" className={linkClass}>Home</NavLink>
              <NavLink to="/bookings" className={linkClass}>Bookings</NavLink>
              <NavLink to="/profile" className={linkClass}>Profile</NavLink>
              <button onClick={handleRefreshCatalog} title="Refresh catalog" className="ml-2 w-10 h-10 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors">
                <RefreshCw className="w-4 h-4" />
              </button>
              <button onClick={() => nav('/cart')} className="relative w-10 h-10 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors">
                <ShoppingCart className="w-4 h-4" />
                {cartCount > 0 && (
                  <span className="absolute -top-1 -right-1 bg-[#EA580C] text-white text-[10px] font-bold rounded-full w-4 h-4 flex items-center justify-center">{cartCount}</span>
                )}
              </button>
              <button className="w-10 h-10 rounded-full bg-neutral-100 hover:bg-neutral-200 flex items-center justify-center transition-colors">
                <Bell className="w-4 h-4" />
              </button>
            </>
          )}
          {user && role === 'cleaner' && (
            <>
              <NavLink to="/cleaner/dashboard" className={linkClass}>Dashboard</NavLink>
              <NavLink to="/cleaner/jobs" className={linkClass}>Jobs</NavLink>
              <NavLink to="/cleaner/earnings" className={linkClass}>Earnings</NavLink>
              <NavLink to="/cleaner/attendance" className={linkClass}>Attendance</NavLink>
              <NavLink to="/cleaner/profile" className={linkClass}>Profile</NavLink>
            </>
          )}
          {!user && (
            <>
              <button onClick={() => nav('/login')} className="text-sm font-semibold text-neutral-700 hover:text-[#2E7D32] px-3 py-2">Log in</button>
              <button onClick={() => nav('/signup')} className="text-sm font-semibold bg-[#2E7D32] hover:bg-[#276D2A] text-white px-4 py-2 rounded-lg transition-colors">Sign up</button>
            </>
          )}
          {user && (
            <div className="ml-2 flex items-center gap-2 pl-3 border-l border-neutral-200">
              <div className="w-9 h-9 rounded-full bg-[#E8F5E9] flex items-center justify-center">
                <User className="w-4 h-4 text-[#2E7D32]" />
              </div>
              <div className="text-xs">
                <p className="font-semibold leading-none">{user.name}</p>
                <button onClick={handleLogout} className="text-neutral-500 hover:text-red-600 flex items-center gap-0.5 mt-1"><LogOut className="w-3 h-3" /> Log out</button>
              </div>
            </div>
          )}
        </nav>
      </div>
    </header>
  );
};

export default DesktopHeader;
